module.exports = __webpack_public_path__ + "img/440.7d27ead0.jpg";